import axios from 'axios';
import authHeader from '../auth-header';
import tokenHeader from '../token-header';

import baseUrl from '../base-url';

const API_URL = baseUrl()+"/api/all/";
const getBeranda = 'beranda';
const getStatistikSertifikasiDanRpl = 'beranda-statistik-sertifkasi-dan-rpl';
const petaSebaran = 'data-test-center-statistik';
const petaSebaranById = 'data-test-center/';

class BerandaService {    
    getPetaSebaran() {
        return axios.get(
            API_URL + petaSebaran ,
            {
                
                headers: authHeader()
            }
        );
    }
    getBeranda(tahun) {
        return axios.get(
        API_URL + getBeranda ,
        {
            params : {
                tahun : tahun
            },
            headers: authHeader()
        });
    }    

    getStatistikSertifikasiDanRpl(tahun) {
        return axios.get(
            API_URL + getStatistikSertifikasiDanRpl ,
            {
                params : {
                    tahun : tahun
                },
                headers: authHeader()
            }
        );
    }
    
   

}

export default new BerandaService();
